import { snakeCase } from "lodash/string";

/**
 * Returns the value of a environmental key or returns fallback if that key does not exist
 * @param {string} key
 * @param {any} fallback
 * @return {string|null}
 */
export const getConfigValue = (key, fallback = null) => {
	const keyUppered = snakeCase(key).toUpperCase();
	if (process.env.hasOwnProperty(keyUppered)) {
		return process.env[keyUppered];
	}

	console.warn(`Could not find config parameter with key "${keyUppered}" derived from "${key}`);
	return fallback;
};

/**
 * Returns the enviroment from the .env file
 * @return {string}
 */
export const getEnv = () => process.env.REACT_APP_ENV || "dev";

/**
 * Returns boolean if the environment matches given name, this is case insensitive
 * @param {string} environmentName
 * @return {boolean}
 */
export const isEnv = (environmentName) => getEnv().toUpperCase() === environmentName.toUpperCase();
